import React from 'react';

const LibrarySong = ({song,songs,setCurrentSong,id,audioRef,isPlaying,setSongs}) => {
    //
    const songSelectHandler = async () => {
        await setCurrentSong(song);
        //加上active state，標示選取的歌曲顏色
        const newSongs = songs.map((song) => {
            if(song.id === id){
                return{
                    ...song,
                    active: true,
                }
            }else{
                return{
                    ...song,
                    active: false,
                }
            }
        })
        setSongs(newSongs)
        //檢查歌曲是否isplaying，有的話就播放歌曲
        if(isPlaying) audioRef.current.play()
    }
    return (
        <div onClick={songSelectHandler} className={`library-song ${song.active ? 'selected': ""}`}>
            <img src={song.cover} alt={song.name} />
            <div className="song-description">
                <h3>{song.name}</h3>
                <h4>{song.artist}</h4>
            </div>
        </div>
    )
}

export default LibrarySong
